import React from "react";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import IconSelector from "../BuilderComponents/IconSelector/IconSelector";

const EditIconSelector = ({ editElementData, setEditElementData }) => {
  const currentIcon = editElementData?.icon_class?.split(" ")[0];

  const handleSelect = (newIcon) => {
    setEditElementData({ ...editElementData, icon_class: newIcon });
  };

  return (
    <div className="edit_icon_selector_block">
      <div className="edit_icon_preview_only">
        <MaterialIcon name={currentIcon || "apps"} />
      </div>
      <IconSelector callbackFunction={handleSelect} />
    </div>
  );
};

export default EditIconSelector;
